const ErrorFallback = () => (
  <div>
    <h1>OOOPS... SOMETHING WENT WRONG</h1>
    <h2>immediately call Gal Weiss - he's your man</h2>
  </div>
);

export default ErrorFallback;
